import React, { useState, useEffect } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { Modal } from 'react-bootstrap'

import { isTokenValid } from '../utils/authVerify'
import { LoadingAnimeSpinner } from '../component/common/Loaders'
import { CSRF_COOKIE_NAME } from '../utils/config'

type Action = 'loading' | 'login' | null

const ONE_HOUR_MS = 60 * 60 * 1000

const hasRecentValidCheck = (): boolean => {
  const lastCheckStr = localStorage.getItem('lastTokenCheck')
  if (!lastCheckStr) return false
  
  const lastCheckTime = parseInt(lastCheckStr, 10)
  return (Date.now() - lastCheckTime) < ONE_HOUR_MS
}

const PrivateRoutes: React.FC = () => {
  const [action, setAction] = useState<Action>('loading')
  const [tokenValid, setTokenValid] = useState<boolean>(false)

  const checkToken = async (): Promise<void> => {
    const cookies = document.cookie.split(';')
    const cookieExist = cookies.some(cookie => cookie.trim().startsWith(`${CSRF_COOKIE_NAME}=`))
    
    if (hasRecentValidCheck() && cookieExist) {
      setTokenValid(true)
      return
    }

    const token = await isTokenValid()
    if (token) {
      localStorage.setItem('lastTokenCheck', Date.now().toString())
      setTokenValid(true)
    } else {
      localStorage.removeItem('lastTokenCheck')
      setAction('login')
    }
  }

  useEffect(() => {
    checkToken()
  }, [])  // eslint-disable-line

  return (
    tokenValid
      ? <Outlet />
      : action === 'loading'
        ? <Modal show={true} fullscreen={true} contentClassName="bg-white shadow-none border-0" centered>
          <Modal.Body className='d-flex justify-content-center align-items-center'>
            <LoadingAnimeSpinner />
          </Modal.Body>
        </Modal>
        : action === 'login'
          ? <Navigate to='/login' />
          : <></>
  )
}

export default PrivateRoutes
